import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";

import { Draft } from "immer";

export type ViewType = "List" | "Grid" | "Table" | "Catalog"

export interface ProductListViewState {
    view?: ViewType | undefined;
}

const initialState: ProductListViewState = {
    view: undefined,
};
const ProductListViewReducer = {
   
    "Custom/ProductList/SetView": (
        draft: Draft<ProductListViewState>,
        action: {
            parameter: {view: ViewType};
        },
    ) => {
        draft.view = action.parameter.view;
    },
};

export default createTypedReducerWithImmer(initialState, ProductListViewReducer);